export default __webpack_public_path__ + "static/media/view.59547ce6.svg";